import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("mrshu_customer_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("mrshu_admin_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return e?.message || "Something went wrong. Please try again.";
}

export function deviceId() {
  let d = localStorage.getItem("mrshu_device_id");
  if (!d) {
    d = (window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(16).slice(2));
    localStorage.setItem("mrshu_device_id", d);
  }
  return d;
}
